export default "__VITE_ASSET__z5QMCabV__"